<template>
  <div ref="pbrTopicRegionDistChart" class="pbr-topic-chart-container" style="height: 200px;">
  </div>
</template>

<script>
import * as echarts from 'echarts'
import {chartColors} from '../analysis/constant'

export default {
  region: 'pbrTopicRegionDistChart',
  props: {
    data: {
      type: Array,
      require: true,
      default: () => []
    }
  },
  data () {
    return {
      chartData: []
    }
  },
  computed: {
    isDark () {
      return this.$store.state.brpaModule.theme === 'dark'
    }
  },
  methods: {
    drawChart (theme = 'light') {
      let self = this
      if (this.pbrTopicRegionDistChart) {
        this.pbrTopicRegionDistChart.dispose()
      }
      // {renderer: 'svg',}
      if (this.$refs.pbrTopicRegionDistChart) {
        this.pbrTopicRegionDistChart = echarts.init(this.$refs.pbrTopicRegionDistChart, theme, {devicePixelRatio: 2.5})
        this.pbrTopicRegionDistChart.resize({width: 200})
        this.pbrTopicRegionDistChart.setOption(this.optionPbrTopicRegionDist)
        this.pbrTopicRegionDistChart.on('click', function (param) {

        })
      }
    },
    generateOptions () {
      let self = this
      this.optionPbrTopicRegionDist = {
        color:chartColors,
        title: {
          show: false,
          text: self.$t('charts.special.regionalDistribution.name'),
          left: '52%',
          bottom: 20
        },
        tooltip: {
          trigger: 'item',
          formatter: function (a) {
            console.log(a)
            // return params.name + " - " + params.percent + '%'
            let listItem = `${a.seriesName}<br /><i style="display: inline-block;width: 10px;height: 10px;background: ${a.color};margin-right: 5px;border-radius: 50%;}"></i>
                            ${a.value.region} ：${a.value.percent}</p>`

            return '<div class="showBox">' + listItem + '</div>'
          }
        },
        legend: {
          type:'scroll',
          orient: 'horizontal',
          bottom: 10,
          itemHeight: 10,
          itemWidth: 10,
          textStyle: {
            fontSize: 10,
            lineHeight: 10,
            color: self.isDark ? '#fff' : '#101010'
          },
          tooltip: {
            show: true,
            extraCssText: 'box-shadow: 0 0 3px rgba(0, 0, 0, 0.3);'
          },
          formatter: function (name) {
            if (!name) return ''
            // 超出几个字符隐藏，鼠标悬浮时显示
            if (name.length > 6) {
              name = name.slice(0, 6) + '...'
            }
            return name
          }
        },
        dataset: {
          dimensions: ['region', 'num', 'percent','id', ],
          source: this.chartData
        },

        series: [
          {
            name: self.$t('charts.special.regionalDistribution.name'),
            type: 'pie',
            radius: ['35%', '70%'],
            // center: [this.showTitle ? '50%' : '35%', '50%', '50%'],
            center: ['35%', '50%', '50%'],
            avoidLabelOverlap: false,
            label: {
              //   show: false,
              normal: {
                formatter: '{@percent}',
                position: 'inside',
                fontSize: 8,
                color: '#fff',
                align: 'center',
                verticalAlign: 'middle'
              }
            },
            emphasis: {
              label: {
                show: true,
                fontSize: '8',
                fontWeight: 'bold'
              }
            },
            labelLine: {
              show: false
            },
            grid: {
              top: this.showTitle ? 40 : 0,
              containLabel: true
            }
          }
        ]
      }
    }
  },
  mounted () {
    const pbrTopicRegionDistChartData = this.data
    if (pbrTopicRegionDistChartData && pbrTopicRegionDistChartData.length > 0 && pbrTopicRegionDistChartData[0].hasOwnProperty('percent')) {
      pbrTopicRegionDistChartData.forEach(p => p.num = parseFloat(p.percent))
      this.chartData = pbrTopicRegionDistChartData
    } else {
      this.chartData = [{id: '', region: '',num:0, percent: 0}]
    }
    if (this.pbrTopicRegionDistChart) {
      this.pbrTopicRegionDistChart.dispose()
    }

    this.generateOptions()
    this.drawChart(this.theme)
  },
  watch: {
    data: {
      handler (newValue, oldValue) {

        const pbrTopicRegionDistChartData = newValue
        if (pbrTopicRegionDistChartData && pbrTopicRegionDistChartData.length > 0 && pbrTopicRegionDistChartData[0].hasOwnProperty('percent')) {
          pbrTopicRegionDistChartData.forEach(p => p.num = parseFloat(p.percent))
          this.chartData = pbrTopicRegionDistChartData
        } else {
          this.chartData = [{id: '', region: '', num: 0 , percent: 0}]
        }
        if (this.pbrTopicRegionDistChart) {
          this.pbrTopicRegionDistChart.dispose()
        }
        this.generateOptions()
        this.drawChart(this.theme)
      }
      // immediate: true
    },
    isDark (n, o) {
      this.generateOptions()
      this.drawChart(this.theme)
    }
  }
}
</script>

<style scoped>

</style>
